import { render } from "./tagQuery.vue?vue&type=template&id=194c4345&scoped=true"
import script from "./tagQuery.vue?vue&type=script&lang=js"
export * from "./tagQuery.vue?vue&type=script&lang=js"

import "./tagQuery.vue?vue&type=style&index=0&id=194c4345&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-194c4345"

export default script